module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container table-data"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [(_vm.commercials.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "commercial_id"
    }
  }, [(_vm.commercials.length > 1) ? _c('el-select', {
    attrs: {
      "placeholder": "全部"
    },
    on: {
      "change": function($event) {
        return _vm.getShopList()
      }
    },
    model: {
      value: (_vm.queryForm.commercial_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "commercial_id", $$v)
      },
      expression: "queryForm.commercial_id"
    }
  }, _vm._l((_vm.commercials), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.commercials.length == 1) ? _c('el-input', {
    attrs: {
      "type": "text",
      "value": _vm.commercials[0].name,
      "disabled": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shops.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始日期",
      "prop": "startDate1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.queryForm.startDate1),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startDate1", $$v)
      },
      expression: "queryForm.startDate1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束日期",
      "prop": "endDate1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.queryForm.endDate1),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endDate1", $$v)
      },
      expression: "queryForm.endDate1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel()
      }
    }
  }, [_vm._v("导出excel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.handleDataSummary
    }
  }, [_vm._v("数据求和")]), _vm._v(" "), (_vm.showSummaryInfo) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px",
      "color": "red"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("求和周期:" + _vm._s(_vm.summaryInfo.summaryPeriod))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("总退订单数:" + _vm._s(_vm.summaryInfo.totalRefundNum))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("总营业额:" + _vm._s(_vm.summaryInfo.totalPayCallback))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("总退款额:" + _vm._s(_vm.summaryInfo.totalRefundAmount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("总结算额:" + _vm._s(_vm.summaryInfo.totalSettleAmount))])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.shopDataChange()
      }
    }
  }, [_vm._v("店铺数据调整")]), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "10px"
    }
  }, [_vm._v("各食堂在线销售汇总")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("实时数据报表仅支持查看近30天的数据")])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "span-method": _vm.objectSpanMethod
    }
  }, _vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width
      }
    })
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "店铺顺序调整",
      "visible": _vm.dialogVisible,
      "center": "",
      "width": "70%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.shopData,
      "max-height": "500",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "width": "200px",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "disabled": scope.$index === 0,
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              scope.$index === 0 ? '' : _vm.move(scope.row, scope.$index, 1)
            }
          }
        }, [_vm._v("\n            上移\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": scope.$index === _vm.shopData.length - 1,
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              scope.$index === _vm.shopData.length - 1 ? '' : _vm.move(scope.row, scope.$index, 2)
            }
          }
        }, [_vm._v("\n            下移\n          ")])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d2a3aaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/report/commercial/order.vue
// module id = 872
// module chunks = 0